/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 */

import styled from 'styled-components';

import { fontSizeSmall } from '../../../../../../theme/default/global';
import { WidgetBlockStyled } from '../../styled/WidgetContainerStyled';
import {
    WidgetEmptyCircleStyled,
} from '../../styled/WidgetStyled';

export const WidgetOrderInquiriesEmptyStyled = styled.div`
`;

export const WidgetOrderInquiriesEmptyContainer = styled(WidgetEmptyCircleStyled)`

`;

export const WidgetOrderInquiriesStyled = styled(WidgetBlockStyled)`
    display: flex;
    flex-direction: column;
    min-height: 348px;
`;

export const WidgetOrderInquiriesEmptyLabelTipsStyled = styled.div`
    width: 205px;
    margin: 0 auto 8px;
    text-align: center;
    opacity: 0.5;
`;

export const WidgetOrderInquiriesListItemDateStyled = styled.div`
    font-size: ${fontSizeSmall};
    line-height: 1.33;
    opacity: 0.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
